import { useLocation, useNavigate } from 'react-router-dom';

// Cross-tree leave guard. A page with unsaved work that lives only in its
// state registers `isDirty` and `request` here so navigation UI outside its
// subtree — the header's page links, the sidebar footer's Settings gear and
// Logout — can ask before unmounting it. `request(proceed)` shows the page's
// own prompt and runs `proceed` if the user chooses to leave. One page is
// mounted at a time, so a single slot suffices; each page resets it on unmount.
// Registered by: the Agent page (unsent canvas edits) and the Data page
// (unsaved table settings).
const canvasEditGuard = {
  isDirty: () => false,
  request: null,
};

export function guardAction(action) {
  if (canvasEditGuard.isDirty() && canvasEditGuard.request) {
    canvasEditGuard.request(action);
    return;
  }
  action();
}

export function useGuardedLinkClick() {
  const navigate = useNavigate();
  const location = useLocation();
  return (to) => (event) => {
    if (location.pathname === to || !canvasEditGuard.isDirty()) return;
    event.preventDefault();
    canvasEditGuard.request?.(() => navigate(to));
  };
}

export default canvasEditGuard;
